import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';
import { CitiSession } from 'store/types/payments/Citi';
import { httpRequestWrapper } from 'util/Request';

class PaymentProviderService {
  public static getCitiSession(subsidiaryId?: string): Promise<CitiSession> {
    return new Promise<CitiSession>((resolve: (confirmData: CitiSession) => void, reject: (error: string) => void) => {
      httpRequestWrapper<CitiSession>(
        HttpService.get(`${API_URL}/payment/citi?subsidiaryId=${subsidiaryId}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }
}

export default PaymentProviderService;
